import { media, style as s } from "typestyle";
import * as Style from "../../styles";

export const component = s({
  fontFamily: Style.text.font.main,
  alignItems: "center",
  backgroundColor: Style.colors.darkTranslucent100,
});
